import { render, staticRenderFns } from "./AddImageForm.vue?vue&type=template&id=6f40b8f8"
import script from "./AddImageForm.vue?vue&type=script&lang=js"
export * from "./AddImageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports